import React, { Component } from 'react';
import { BgMaxPrice } from '~/Api/User/ProductGroup/BgMaxPrice';
import { formatCountriesError } from '~/UI';
import CountryIcon from '~/UI/CountryIcon';
import Heading from '~/UI/Heading';

import styles from './styles.less';

interface Props {
	bgMaxPrice: BgMaxPrice;
}

export default class Calculation extends Component<Props> {
	public render() {
		const {
			bgMaxPrice: { finalCalculation },
		} = this.props;

		return (
			<div className={styles.container}>
				<div className={styles.columns}>
					<div className={styles.leftColumn}>
						<Heading level={3}>Lowest reference price:</Heading>
						{finalCalculation.ceilingPrice?.fromProducts.map((product, i) => (
							<div
								className={styles.row}
								data-product-id={product.id}
								data-testid={`lowest-exfactory-price-${i}`}
								key={product.id}
							>
								<span className={styles.number}>{i + 1}.</span>

								<span className={styles.countryIcon}>
									<CountryIcon code={product.dataSource.country.alpha2} name={product.dataSource.country.name} />
								</span>

								<span className={styles.countryDescription}>
									{product.dataSource.country.alpha2}
									<br />
									{product.dataSource.shortName}
								</span>
							</div>
						))}
					</div>
					<div className={styles.centerColumn}>
						<Heading level={3}>Calculated max price:</Heading>

						<div className={styles.row}>
							<p className={styles.rowName}>Ceiling price (lowest ex-factory price):</p>
							<p className={styles.rowValue}>
								{finalCalculation.ceilingPrice !== null ? (
									<strong>{finalCalculation.ceilingPrice.price.roundedHumanFormat()}</strong>
								) : null}
							</p>
						</div>

						<div className={styles.row}>
							<p className={styles.rowName}>Generic reference price (70%):</p>
							<p className={styles.rowValue}>
								{finalCalculation.genericReferencePrice !== null ? (
									<strong>{finalCalculation.genericReferencePrice.roundedHumanFormat()}</strong>
								) : null}
							</p>
						</div>

						<div className={styles.row}>
							<p className={styles.rowName}>Biosimilars reference price (80%):</p>
							<p className={styles.rowValue}>
								{finalCalculation.biosimilarReferencePrice !== null ? (
									<strong>{finalCalculation.biosimilarReferencePrice.roundedHumanFormat()}</strong>
								) : null}
							</p>
						</div>

						{finalCalculation.emptyResultReason.length > 0 ? (
							<div className={styles.row}>
								<p>{this.renderEmptyResultReason()}</p>
							</div>
						) : null}
					</div>
					<div className={styles.rightColumn}>
						<Heading level={3}>&nbsp;</Heading>
						{finalCalculation.referencedProduct !== null ? (
							<div className={styles.row}>
								<p className={styles.smallRowName}>
									Current ex-factory price ({finalCalculation.referencedProduct.dataSource.shortName}):
								</p>
								<p className={styles.smallRowValue}>
									<strong>{finalCalculation.referencedProduct.currentExFactoryPrice.roundedHumanFormat()}</strong>
								</p>
							</div>
						) : null}
					</div>
				</div>
			</div>
		);
	}

	private renderEmptyResultReason() {
		const {
			bgMaxPrice: { finalCalculation },
		} = this.props;
		const countryError = finalCalculation.findMaxOneReferenceProductError();

		if (finalCalculation.hasMissingProductSettings()) {
			return <strong className={styles.rowError}>Some products settings are missing</strong>;
		}
		if (finalCalculation.requiresMinOneReferenceProductErrorCode()) {
			return <strong className={styles.rowError}>Calculation requires at least one reference country product</strong>;
		}
		if (countryError !== null) {
			return (
				<strong className={styles.rowError}>
					Calculation requires at most one product for each reference country
					{formatCountriesError(countryError.duplicateCountries)}
				</strong>
			);
		}
		if (finalCalculation.isMissingReferenceSettings()) {
			return <strong className={styles.rowError}>Calculation requires reference settings</strong>;
		}
		if (finalCalculation.isIllegalProductPriceTypeSelected()) {
			return <strong className={styles.rowError}>Some products have illegal price selected</strong>;
		}
		return null;
	}
}
